import { css, FlattenSimpleInterpolation } from "styled-components";
import colors from "./colors";

type breakpointsProps = {
  mobile: string;
  tablet: string;
  pc: string;
  mobileAndTablet: string;
  pcAndTablet: string;
  minimized: string;
};

const breakpoints: breakpointsProps = {
  mobile: "(min-width: 320px) and (max-width: 559px)",
  tablet: "(min-width: 560px) and (max-width: 1025px)",
  pc: "(min-width: 1026px)",
  mobileAndTablet: "(min-width: 320px) and (max-width: 1025px)",
  minimized: "(max-width: 1025px)",
  pcAndTablet: "(min-width: 560px)",
};

const defaultBoxSizing: FlattenSimpleInterpolation = css`
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box; /* Opera/IE 8+ */
`;

const defaultInputStyle: FlattenSimpleInterpolation = css`
  height: 40px;
  border: 1px solid #8e8c8c;
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 16px;

  &:hover,
  &:focus{
    border: 1px solid ${colors.secondary};
  }

  &:focus {
    box-shadow: 0 0 0 2px #acdbda;
  }
`;

const mainContainerStyle: FlattenSimpleInterpolation = css`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  background-color: ${colors.custom.background};
`;

const defaultBoxShadow: FlattenSimpleInterpolation = css`
  box-shadow: 0px 0px 4px rgba(176, 139, 0, 0.1);
`;

const defaultContainerBoxShadow: FlattenSimpleInterpolation = css`
  box-shadow: 0px 4px 4px rgba(176, 139, 0, 0.1);
`;
const formErrorMobileView: FlattenSimpleInterpolation = css`
  .ant-form-item-explain.ant-form-item-explain-error {
    @media ${breakpoints.mobileAndTablet} {
      font-size: 12.6px;
    }
  }
`;
const hideScrollbar: FlattenSimpleInterpolation = css`
  ::-webkit-scrollbar {
    display: none;
  }
`;
const gutter: object = { xs: 4, sm: 8, md: 12, lg: 16 };

// eslint-disable-next-line no-restricted-globals
const screenWidth = screen.width;
// eslint-disable-next-line no-restricted-globals
const screenHeight = screen.height;
const modalWidth = 768;
const exportObj = {
  breakpoints,
  defaultBoxSizing,
  defaultInputStyle,
  mainContainerStyle,
  defaultBoxShadow,
  defaultContainerBoxShadow,
  gutter,
  colors,
  screenWidth,
  screenHeight,
  formErrorMobileView,
  hideScrollbar,
  modalWidth,
};

export default exportObj;
